import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=3107df6b&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=js&"
export * from "./Single.vue?vue&type=script&lang=js&"
import style0 from "./Single.vue?vue&type=style&index=0&id=3107df6b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107df6b",
  null
  
)

export default component.exports